import { render, staticRenderFns } from "./CompanyRegistrationComplete.vue?vue&type=template&id=e499b77c&scoped=true&"
import script from "./CompanyRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegistrationComplete.vue?vue&type=style&index=0&id=e499b77c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e499b77c",
  null
  
)

export default component.exports